import { CommonModule } from '@angular/common';
import { Component, input, model } from '@angular/core';

export type ToggleSizes = 'small' | 'medium' | 'large';

@Component({
  selector: 'ui-toggle',
  imports: [ CommonModule ],
  templateUrl: './toggle.component.html',
  styleUrl: './toggle.component.scss',
})
export class ToggleComponent {
  /** A unique name identifier for the toggle component.
   *  The name is a string generated with a random hexadecimal number.
  */
  name = input<string>(`ui-toggle-${(Math.round((Math.random() * 100000000)).toString(16))}`);
  /** Boolean state representing the toggle's on/off value. */
  value = model<boolean>(false);
  /** Defines the size of the toggle.  */
  size = input<ToggleSizes>('large');
  /** Whether the toggle is disabled and cannot be switched. */
  disabled = input<boolean>(false);
  /** Accessible name for the underlying checkbox, for toggles without a visible label. */
  ariaLabel = input<string>();

  /** Toggles the current state of the component. */
  toggleChecked() {
    if (this.disabled()) return;

    this.value.set(!this.value());
  }
}
